// One build is one app for one network. New apps reuse this source with a
// different REACT_APP_BUSINESS_NETWORK build setting.
export const APP_NETWORK = process.env.REACT_APP_BUSINESS_NETWORK || "Billund";
